import axios from "axios";
import { SERVER_URL } from "../config/config";

class CommitteeServices {
  private static serverURL = SERVER_URL;

  private static get axiosConfig() {
    return {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
  }

  public static async getCommittees(sectionId?: number, type?: "committee" | "subcommittee") {
    const apiUrl = `${this.serverURL}/api/committee`;
    const params: { sectionId?: number; type?: string } = {};
    if (sectionId) params.sectionId = sectionId;
    if (type) params.type = type;
    return axios.get(apiUrl, { ...this.axiosConfig, params });
  }

  public static async createCommittee(body: { SectionId: number; Name: string; Type: "committee" | "subcommittee" }) {
    const apiUrl = `${this.serverURL}/api/committee`;
    return axios.post(apiUrl, body, this.axiosConfig);
  }

  public static async updateCommittee(id: number, body: { Name: string; Type: "committee" | "subcommittee" }) {
    const apiUrl = `${this.serverURL}/api/committee/${id}`;
    return axios.put(apiUrl, body, this.axiosConfig);
  }

  public static async deleteCommittee(id: number) {
    const apiUrl = `${this.serverURL}/api/committee/${id}`;
    return axios.delete(apiUrl, this.axiosConfig);
  }

  public static async getMemberCommittees(memberId: number) {
    const apiUrl = `${this.serverURL}/api/committee/member-committees`;
    return axios.get(apiUrl, {
      ...this.axiosConfig,
      params: { memberId },
    });
  }

  public static async assignMemberCommittee(body: {
    MemberSectionId: number;
    CommitteeId: number;
    Role: "Chair" | "Co-Chair";
  }) {
    const apiUrl = `${this.serverURL}/api/committee/member-committees`;
    return axios.post(apiUrl, body, this.axiosConfig);
  }

  public static async removeMemberCommittee(assignmentId: number) {
    const apiUrl = `${this.serverURL}/api/committee/member-committees/${assignmentId}`;
    return axios.delete(apiUrl, this.axiosConfig);
  }
}

export default CommitteeServices;
